<template>
  <div class="map-wrapper9">
    <el-dialog title="选择地址" :visible.sync="showaddress" width="1200px" height="550px" :close-on-click-modal="false"
      :append-to-body="false" :modal-append-to-body="false" :z-index="3100" center>
      <div id="container9" style="width:1160px;height:530px;position:relative;z-index:9;"></div>
      <div id="inputTip">

        <el-row>
          <!-- <el-button type="primary" @click="rulerActive" round plain size="mini">测距工具</el-button> -->
          <el-button type="primary" round plain @click="startEdit" size="mini" v-if="serviceArea">编辑范围</el-button>
          <el-select v-model="serviceRange" placeholder="服务范围KM">
            <el-option v-for="(item, index) in serviceRangeList" :key="index" :label="item ==999? '全城接单': item+'公里'"
            :value="item"></el-option>
          </el-select>
          <el-button type="primary" round plain @click="addMakerTool" size="mini">选择标记</el-button>
          <el-button type="primary" round plain @click="savePosition(false)" size="mini">保存位置</el-button>
        </el-row>

        <el-row style="margin-top:5px;margin-bottom: 5px;">  
          <el-select v-model="tempSelect" placeholder="选择历史范围" @change="chooseHistory"  style="width:280px;" clearable>
            <el-option v-for="(item, index) in historyList" :key="index" :label="item.operTime+item.operName" :value="item.actionId"></el-option>
          </el-select>
           <el-button type="primary" round plain @click="savePosition(true)" size="mini">保存所选历史位置</el-button>
          <!-- <el-button type="primary" round plain @click="readdmark" size="mini">清除范围</el-button> -->
          <!-- <span style="color:red">若所选范围覆盖较大，需清除地图范围后再操作</span> -->
          </el-row>
        <el-row>
          <label>搜索位置：</label>
        </el-row>
        <el-row>
          <!-- onfocus="this.value=''" -->
          <input type="text" style="width: 280px;" id="keywordAMap" name="keywordAMap" value v-model="keywords"
            @focus="keywords = ''" />
          <el-button type="primary" @click="searchMap" size="mini">搜索位置</el-button>
        </el-row>
        <el-row>所选经纬度：{{ servicePosition }}<br />位置：{{ serviceLngLat }}</el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showaddress = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "./css/index.css";
import moment from "moment";
import service from "@/script/api/service.js";
import workercrmapi from "@/script/api/workercrmapi";
export default {
  data() {
    return {
      polyEditor:'',
      path:'',
      serviceArea:'',
      currentPoly:'',
      polygonList: [],
      searchMarker: '',
      keywords: '',
      showaddress: false,
      map: "",
      polygon: "",
      polygonGroup: [],
      polyEditor: "",
      mouseTool: "",
      path: [],
      polygonNum: 0, //绘制的多边形数量
      pointMark: "",
      ruler: '',//测距工具
      markerOverlays: [], //存储所有点
      circleList: [],//存储所有圆

      geocoder: null,//解析经纬度获取地址插件
      servicePosition: '',
      serviceLngLat: '',
      workerId: null,
      serviceRange: 0,

      workerNo:'',
      historyList:[],
      tempSelect:'',

      serviceRangeList: [999 , 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  mounted() {

  },
  activated() { 
    // this.init();
    // this.clearKeywordAMap();
  },
  methods: {
    showWorkerAddress(workerId) {
      this.showaddress = true;
      this.workerId = workerId;
      let that = this;
 
      setTimeout(() => {
        that.init();
        that.clearKeywordAMap();
        that.loadPosation();
      }, 200);
    },
    loadHistory(){
          workercrmapi.$axiosGetWorkerHistoryUpdateArea({ workerNo: this.workerNo }).then(res => {
            this.historyList=res.data.data; 
          })
    },
    chooseHistory(){ 
      console.log(this.tempSelect)
      if(this.tempSelect==''||this.tempSelect==null){
        this.loadPosation();
      }else{

        this.markerOverlays.forEach(mk => {
          mk.setMap(null);
        });
        this.polygonList.forEach(mk => {
         mk.setMap(null);
        });

        let that=this;
        let dt=null;
        this.historyList.forEach(f=>{
          if(f.actionId==that.tempSelect){
            dt=f;
          }
        })
 
         
        this.servicePosition = dt.servicePosition;
        this.serviceLngLat = dt.serviceLngLat;
        this.serviceRange=dt.serviceRange; 
        this.serviceArea=dt.serviceArea; 
         
        let marker = new AMap.Marker({
          position: new AMap.LngLat(this.serviceLngLat.split(',')[0], this.serviceLngLat.split(',')[1]),
          content: "<div style='background:#dcdfe6;width:150px;height:25px;font-size:12px'>"+dt.operTime+dt.operName+"</div>",
          raiseOnDrag: true
        });
        this.map.add(marker);
        this.markerOverlays.push(marker);
        this.map.setFitView([marker]);

       this.path=this.serviceArea.split("|");
        let area =this.path.map(item => {
            return item.split(",");
          });
          // console.log(area);
          let polygon = new AMap.Polygon({
            path: area,
            strokeColor: "#FF33FF",
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
            fillColor: "yellow",
            zIndex:50
          });

          that.map.add(polygon);
          that.polygonList.push(polygon);
          that.currentPoly=polygon; 

        setTimeout(() => {
          that.map.setZoom(11); 
        }, 500);

         
      }
    }, 
    loadPosation() {
      let that=this;
      this.markerOverlays.forEach(mk => {
        mk.setMap(null);
      });
      // this.circleList.forEach(mk => {
      //   mk.setMap(null);
      // });
        this.polygonList.forEach(mk => {
        mk.setMap(null);
      });

      workercrmapi.$axiogetWorkerSupplier({ workerId: this.workerId }).then(res => {
        // console.log(res.data.data.);
        this.workerNo=res.data.data.workerNo;
        this.servicePosition = res.data.data.servicePosition;
        this.serviceLngLat = res.data.data.serviceLngLat;
        this.serviceRange=res.data.data.serviceRange; 
        this.serviceArea=res.data.data.serviceArea; 
        that.loadHistory();
        if (res.data.data.serviceLngLat != '') {
          // this.servicePosition = res.data.data.servicePosition;
          // this.serviceLngLat = res.data.data.serviceLngLat;

          let marker = new AMap.Marker({
            position: new AMap.LngLat(this.serviceLngLat.split(',')[0], this.serviceLngLat.split(',')[1]),
            content: "<div style='background:red;width:80px;height:30px;font-size:20px'>所选位置</div>",
            raiseOnDrag: true
          });
          this.map.add(marker);
          this.markerOverlays.push(marker);
          this.map.setFitView([marker]);


          if (this.serviceRange != '' && this.serviceArea) {
            // var circle = new AMap.Circle({
            //   center: [this.serviceLngLat.split(',')[0], this.serviceLngLat.split(',')[1]],
            //   radius: this.serviceRange * 1000, //半径
            //   borderWeight: 3,
            //   strokeColor: "#FF33FF",
            //   strokeOpacity: 1,
            //   strokeWeight: 6,
            //   strokeOpacity: 0.2,
            //   fillOpacity: 0.4,
            //   strokeStyle: 'dashed',
            //   strokeDasharray: [10, 10],
            //   // 线样式还支持 'dashed'
            //   fillColor: '#1791fc',
            //   zIndex: 50,
            // })

            // this.map.add(circle);
            // this.circleList.push(circle);
            // // 缩放地图到合适的视野级别
            // // this.map.setFitView([circle]) 

            let area = this.serviceArea;
                area = area.split("|");
              area = area.map(item => {
                return item.split(",");
              });
              // console.log(area);
               let polygon = new AMap.Polygon({
                path: area,
                strokeColor: "#FF33FF",
                strokeWeight: 6,
                strokeOpacity: 0.2,
                fillOpacity: 0.4,
                fillColor: "#09af11",
                zIndex:50
              });

              that.map.add(polygon);
              that.polygonList.push(polygon);
              that.currentPoly=polygon;

          }

          setTimeout(() => {
            that.map.setZoom(11); 
          }, 500);

        }

      })

    },
    init() {
      let _this = this;
      var placeSearch = {};
      _this.map = new AMap.Map("container9", {
        resizeEnable: true,
        // center: [116.397428, 39.90923], //地图中心点
        zoom: 16, //地图显示的缩放级别
        keyboardEnable: false,
      });
      _this.ruler = new AMap.RangingTool(_this.map);

      var autoOptions = {
        input: "keywordAMap", //使用联想输入的input的id
      };
      var autocomplete = new AMap.Autocomplete(autoOptions);
      placeSearch = new AMap.PlaceSearch({ map: _this.map });
      AMap.event.addListener(autocomplete, "select", function (e) {
        console.log("select:", e.poi);
        // _this.placeSearch_CallBack(e.poi);
        _this.map.off('click', this.addMarker);
        _this.mouseTool.close();
        _this.ruler.turnOff();
        placeSearch.setCity(e.poi.adcode);
        placeSearch.search(e.poi.name);
        // placeSearch.getDetails(e.poi.id, function (status, result) {
        //   if (status === "complete" && result.info === "OK") {
        //     console.log("进这里");
        //     _this.placeSearch_CallBack(result);
        //   }
        // });
      });

      console.log(_this.map);

      _this.mouseTool = new AMap.MouseTool(_this.map); 

      let scale = new AMap.Scale({
        visible: false
      })
      _this.map.addControl(scale);
      scale.show();


      AMap.plugin("AMap.Geocoder", function () {
        _this.geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: 'all',
          poitype: ''
        });
      })
    },
    //回调函数
    placeSearch_CallBack(data) {
      console.log("回调函数:", data);
      // this.map.clearMap();
      var poiArr = data.location;
      //添加marker
      this.pointMark = new AMap.Marker({
        position: poiArr,
        map: this.map,
      });

      // this.map.setCenter(this.pointMark.getPosition());
      // this.map.setFitView();
      // this.map.setZoom(19);
    },
 
    // 开始编辑
    startEdit() {
      let that=this;
      // console.log(this.serviceArea);
      // console.log(this.currentPoly);
      if(this.serviceArea==''){
        this.$message.warning('请先保存接单范围');
        return false;
      }
       this.map.off('click', this.addMarker); 
        this.currentPoly.setOptions({
                    fillColor: "#09afff",
                    fillOpacity: 0.6,
                });
          this.map.setFitView( this.currentPoly);
    this.polyEditor = new AMap.PolyEditor(this.map, this.currentPoly);
    // polyEditor.addAdsorbPolygons(this.currentPoly)
    this.polyEditor.open();
      this.polyEditor.on("end", function (event) {
        console.log("触发事件2： end");
        console.log(event.target);
        console.log(event.target.De.path);
        let currentPath = event.target.De.path;
        let path=currentPath.map((item) => {
          return item.lng+','+item.lat;
         
        });
        that.path=path;
        console.log(that.path);
      });
    },
    savePosition(his) {
      if (this.serviceLngLat == '') {
        this.$message.error('请先标记位置');
        return;
      } 
      if (this.serviceRange == ''&&this.serviceRange !=0) {
        this.$message.error('请选择范围，若要关闭接单，请选0公里');
        return;
      }
        if (this.polyEditor) {
        this.polyEditor.close();
      }
      let serviceArea=this.serviceArea;
      if(this.path&&this.path.length>1){
        serviceArea=this.path.join('|');  
     }
      let req = {
        workerId: this.workerId,
        serviceLngLat: this.serviceLngLat,
        servicePosition: this.servicePosition,
        serviceRange: this.serviceRange,
        serviceArea:serviceArea,
        history:his
      };
      workercrmapi
        .$axiosUpdateServicePosition(req)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("操作成功");
            this.loadPosation();
          } else {
            this.$message.error(res.data.data);
          }
        });
    },

    //清除关键字缓存
    clearKeywordAMap() {
      let input = document.getElementById("keywordAMap");
      if (input != undefined) {
        input.value = "";
      }
    },
    rulerActive() {
      this.map.off('click', this.addMarker);
      this.mouseTool.close();
      this.ruler.turnOn();
    },
    readdmark(){
      // this.markerOverlays.forEach(mk => {
      //   mk.setMap(null);
      // });
      this.circleList.forEach(mk => {
        mk.setMap(null);
      });
    },
    // 点击添加标记
    addMakerTool() { 

      let _this = this;
      this.ruler.turnOff();
      console.log(this.mouseTool);
      // this.mouseTool.removeListener('draw');
      // this.mouseTool.off('draw');
      // this.map.off("draw",_this.mouseTool);

      this.map.on('click', _this.addMarker);

      //    this.mouseTool.marker(); 
      // this.mouseTool.on('draw',function(e){
      //   console.log(e);
      //  if(e.obj.CLASS_NAME=="AMap.Marker"){
      //     _this.markerOverlays.push(e.obj);
      //     e.obj.on('dbclick',function(event){
      //       _this.mouseTool.close();
      //       console.log(event);
      //       _this.map.remove(event.target);
      //     });
      //  }
      // }) 
    },
    addMarker(e) {
      let _this = this;
      let lng = e.lnglat.getLng();
      let lat = e.lnglat.getLat()
      console.log(lng, lat);
      let marker = new AMap.Marker({
        position: new AMap.LngLat(lng, lat),
        // icon: './css/poi-marker-default.png',
        content: "<div style='background:red;width:80px;height:30px;font-size:20px'>所选位置</div>",
        // draggable: true,
        // cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: true

      });
      console.log(marker);
      console.log(this.map);

      //只保留一个mark 
      this.markerOverlays.forEach(mk => {
        mk.setMap(null);
      })


      marker.on('click', function (event) {
        console.log(event);
        _this.map.remove(event.target);
      });

      this.markerOverlays.push(marker);
      this.map.add(marker);
      this.map.setFitView([marker]);



      // this.circleList.forEach(mk => {
      //   mk.setMap(null);
      // })
      // var circle = new AMap.Circle({
      //   center: [lng, lat],
      //   radius: this.serviceRange * 1000, //半径
      //   borderWeight: 3,
      //   strokeColor: "#FF33FF",
      //   strokeOpacity: 1,
      //   strokeWeight: 6,
      //   strokeOpacity: 0.2,
      //   fillOpacity: 0.4,
      //   strokeStyle: 'dashed',
      //   strokeDasharray: [10, 10],
      //   // 线样式还支持 'dashed'
      //   fillColor: '#1791fc',
      //   zIndex: 50,
      // })

      // this.map.add(circle);
      // this.circleList.push(circle);


      this.regeoCode(lng + ',' + lat);
    },
    regeoCode(lnglat) {
      let that = this;
      this.geocoder.getAddress(lnglat, function (status, result) {
        if (status === 'complete' && result.regeocode) {
          that.servicePosition = result.regeocode.formattedAddress
          that.serviceLngLat = lnglat;
          // alert(address);
        } else {
          alert('获取标记点位置地址失败')
        }
      });
    },
    searchMap() {
      console.log(this.keywords);
      if (this.keywords == '') {
        this.$message.warning("请输入地址");
        return false;
      }
      this.map.remove(this.searchMarker);
      workercrmapi.$ajaxGeocode({
        address: this.keywords
      })
        .then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            let lnglat = res.data.data;
            this.searchMarker = new AMap.Marker({

              position: [lnglat.split(',')[0], lnglat.split(',')[1]],
              offset: new AMap.Pixel(-13, -30)
            });
            this.map.add(this.searchMarker);
            this.map.setFitView();
          }
        }).catch(() => { });



    },





  },
};
</script>
<style>
.map-wrapper9 {
  width: 100%;
  height: 100%;
  line-height: 1.5;
  font-weight: 300;
  color: #111213;
  font-size: 12px;
}

#container9 {
  position: relative;
  /* z-index: 1; */
}

/* .btn {
  margin-left: 0;
  font-size: 1rem;
  box-sizing: border-box;
} */

button,
input,
select {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  overflow: visible;
  text-transform: none;
}
/* 
.btn {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: transparent;
  background-image: none;
  color: #25a5f7;
  border-color: #25a5f7;
  padding: 0.25rem 0.5rem;
  line-height: 1.5;
  border-radius: 1rem;
  -webkit-appearance: button;
  cursor: pointer;
} */

/* .btn:hover {
  color: #fff;
  background-color: #25a5f7;
  border-color: #25a5f7;
  text-decoration: none;
} */

/* .input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
} */

/* .btn:focus {
  outline: 0;
  box-shadow: none;
} */

#inputTip {
  width: 480px;
  background-color: #ddf;
  color: #333;
  border: 1px solid silver;
  -webkit-box-shadow: 3px 4px 3px 0 silver;
  box-shadow: 3px 4px 3px 0 silver;
  position: absolute;
  top: 60px;
  left: 30px;
  border-radius: 5px;
  overflow: hidden;
  line-height: 20px;
  padding: 6px 8px;
  z-index: 10;
}

  /* #inputTip input[type="text"] {
  height: 25px;
  border: 0;
  padding-left: 5px;
  width: 200px;
  border-radius: 3px;
  outline: none;
}   */
</style>
